// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"370":"5380a8f3","752":"af40fc33","939":"9900850f"}[chunkId] + ".css";
};